import NProgress from 'nprogress'
import axios from 'axios'
import { get } from '../utilities'
import store from '../store'

axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.App.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
}
axios.interceptors.request.use(function (config) {
    NProgress.start()
    if (!config.headers) {
        config.headers = {}
    }
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem('token')
    config.headers['Authorization'] = token ? `Bearer ${token}` : null

    return config
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    NProgress.done()
    return response
}, function (error) {
    NProgress.done()

    if (get(error, 'response.status', 200) == 401) {
        store.commit('LOGOUT')
    }

    return Promise.reject(error)
})

export const query = function(body) {
    return new Promise((resolve, reject) => {
        axios.post('/graphql/query', body)
            .then( ({ data, headers }) => {
                if (get(data, 'errors')) {
                    reject(data.errors)
                }
                else {
                    resolve({ data: data.data, headers: headers })
                }
            }, (error) => {
                reject(error)
            })
    })
}

export const watchQuery = function(body, resolve, reject) {
    query(body).then( (response) => {
        resolve(response)

        setTimeout( () => {
            watchQuery(body, resolve, reject)
        }, body.pollInterval)
    }, (error) => {
        reject(error)
    })
}
